import React, { useCallback } from 'react';
import { Dialog } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import I18N from '@leverege/i18n';
const {
  t,
  tIcon
} = I18N.ns('imagine.operatingHours.OperatingHoursEditor');
export default function DeleteModeDialog(props) {
  const {
    show,
    onClose,
    mode,
    onChange,
    modes = {}
  } = props;
  const onOkay = useCallback(() => {
    onChange?.({
      data: mode
    });
    onClose();
  }, [onChange, mode, onClose]);
  return /*#__PURE__*/React.createElement(Dialog.Question, {
    variant: "itemForm",
    headerVariant: "itemFormHeader|formHeader",
    bodyVariant: "dialogFormBody|itemFormBody|formBody",
    footerVariant: "itemFormFooter|formButtons",
    okayVariant: "primaryDestructive",
    okay: "Delete",
    title: /*#__PURE__*/React.createElement(TitleBar, {
      variant: "dialogTitle",
      title: t('deleteModeTitle'),
      icon: tIcon('deleteModeFormIcon', 'fa fa-fw fa-trash')
    }),
    show: show,
    onClose: onClose,
    onCancel: onClose,
    onOkay: onOkay
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: t('deleteMode', {
        name: `<b>${modes[mode].name}</b>`
      })
    }
  }));
}